export const ENVIRONMENT = 'environment';
export const ENVIRONMENT_SLICE_NAME = `${ENVIRONMENT}Slice`;

const GET_NOW_ENVIRONMENT = `${ENVIRONMENT}/getNowEnvironment`;
const GET_NOW_ENVIRONMENTS = `${ENVIRONMENT}/getNowEnvironments`;
const GET_DAILY_ENVIRONMENT = `${ENVIRONMENT}/getDailyEnvironment`;
const GET_DAILY_ENVIRONMENTS = `${ENVIRONMENT}/getDailyEnvironments`;
const GET_ENVIRONMENT_HISTORIES = `${ENVIRONMENT}/getEvironmentHistories`;
const GET_ENVIRONMENT_EXCEL = `${ENVIRONMENT}/getEnvironmentExcel`;
const GET_ENVIRONMENT_LOCAL = `${ENVIRONMENT}/getEnvironmentLocal`;

export const actions = {
  GET_NOW_ENVIRONMENT,
  GET_NOW_ENVIRONMENTS,
  GET_DAILY_ENVIRONMENT,
  GET_DAILY_ENVIRONMENTS,
  GET_ENVIRONMENT_HISTORIES,
  GET_ENVIRONMENT_EXCEL,
  GET_ENVIRONMENT_LOCAL
};
